<div class="cta">
  <h3>Aan de slag met BGTviewer?</h3>
  <a routerLink="/" class="button">
    Probeer het gratis uit
  </a>
</div>
